<div class="logout-page">
  <div class="logout-card">
    <i class="fa fa-info-circle logout-card__icon" aria-hidden="true"></i>
    <p class="logout-card__message">
      You have successfully logged out. Please close the browser window.
    </p>
    <img
      class="logout-card__logo"
      src="assets/img/pwc-logo-black.png"
      alt="PwC Global Enterprise Tax Solutions"
      />
    </div>
  </div>

  <footer class="footer-style">
    <div class="foot-div">
      <p class="text-center foot-text">
        &copy; 2011-{{ currentYear }} PwC. All Rights Reserved. PwC refers to the US member
        firm of one of its subsidiaries or affiliates, and may sometimes refer to the PwC network.
        Each member firm is a separate legal entity.
      </p>
      <div class="text-center footer-links-row">
        <ul class="list-inline pull-left">
          <li><a target="_blank" rel="tag" href="https://www.pwc.com/us/en/site/privacy.html">Privacy</a></li>
          <li><a target="_blank" rel="tag" href="https://www.pwc.com/us/en/site/privacy-shield.html">Privacy Shield</a></li>
          <li><a target="_blank" rel="tag" href="https://www.pwc.com/us/en/site-information.html">Cookies info</a></li>
          <li><a target="_blank" rel="license" href="http://www.pwc.com/us/en/site/legal.html">Legal</a></li>
          <li><a target="_blank" rel="license" href="https://www.pwc.com/us/en/site/terms-and-conditions.html">Terms and Conditions</a></li>
        </ul>
        <ul class="list-inline pull-right footer-meta">
          <li>{{ hostname }}</li>
          <li>IST</li>
          @if (releaseVersion) {
            <li>{{ releaseVersion }}</li>
          }
        </ul>
      </div>
    </div>
  </footer>
